import { Component, OnInit, OnDestroy, Inject, AfterViewInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AceConfigInterface } from 'ngx-ace-wrapper';
import 'brace';
import 'brace/mode/text';
import 'brace/theme/github';

import 'brace/theme/clouds';
import 'brace/mode/javascript';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-regex-editor',
  templateUrl: './regex-editor.component.html',
  styleUrls: ['./regex-editor.component.css']
})
export class RegexEditorComponent implements OnInit, OnDestroy, AfterViewInit {

  public configText: AceConfigInterface = {
    mode: 'text',
    theme: 'github',
    readOnly : false
  };

  public configJava: AceConfigInterface = {
    mode: 'javascript',
    theme: 'clouds',
    readOnly : false,
    wrap: true
  };

  public content = '';

  isJs: boolean;

  messageChangeObservable: Subscription;

  editorForm: FormGroup;

  /** FormControl for fcComment  */
  fcComment = new FormControl();
  /** FormControl for fcTesting  */
  fcTesting = new FormControl();

  validate: boolean;
  isValid: boolean;

  tempTimeout;

  constructor(@Inject(MAT_DIALOG_DATA) public data, edForm: FormBuilder, public dialogRef: MatDialogRef<RegexEditorComponent>) {

    this.editorForm = edForm.group({
      fcComment: this.fcComment,
      fcTesting: this.fcTesting
    });
  }

  ngOnInit() {
    this.fcTesting.disable();
  }

  ngAfterViewInit() {

    this.messageChangeObservable = this.fcComment.valueChanges.subscribe(data => {
      this.checkCode();
    });

    this.tempTimeout = setTimeout(() => {
      this.content = this.getValue(this.data.code);
      this.validate = true;
      this.isValid = true;
    }, 0);

  }

  getHeader() {
    switch (this.data.type) {
      case 'source': return 'Source';
      case 'message': return 'Message';
      case 'dest': return 'Destination';
      case 'condition': return 'Condition';
      case 'sid': return 'SID';
      case 'content': return 'Content mask';
      default: return '';
    }
  }

  saveEditorData() {
    const result = (this.isJs ? 'js:' : '') + this.getValue(this.content);
    this.dialogRef.close(result);
  }

  getValue(val) {
    if (val && val.length > 3) {
      if (val.substr(0, 3) === 'js:') {
        val = val.slice(3);
      }
    } else {
      val = '';
    }
    return val;
  }

  clearMessage() {
    this.fcComment.patchValue(null);
  }

  checkCode() {
    this.isValid = true;

    const regex           = this.content;
    const lFirst          = regex[0];
    const lLast           = regex[regex.length - 1];
    let reResult   = '';

    const regText = this.fcComment.value;

    // 1 just regular expression
    if (lFirst === '/' && lLast === '/') {
      let result  = [];

      try {
        const regexN = new RegExp(regex.replace(/\/\|\//g, '|').slice(1, -1), 'gmi');
        result = regText.match(regexN);
      } catch (e) {
        this.isValid = false;
      }

      if (result) {
        result.forEach(r => {
          reResult = reResult + ',' + r;
        });

        reResult =  reResult.slice(1);
      }

      this.isJs     = false;
    } else if (!regex) { // blank
      this.isJs = false;
    } else { // 2 javascript code
      try {
        reResult = eval(`
            function execIn(){
              let message = '${regText || ''}';
              ${regex}
            }
            execIn();`);
      } catch (e) {
        reResult = '*** Invalid CODE ***';
        this.isValid = false;
      }
      this.isJs = true;
    }

    this.fcTesting.patchValue(reResult);
  }

  close() {
    this.dialogRef.close(null);
  }

  ngOnDestroy() {
    if (this.messageChangeObservable) {
      this.messageChangeObservable.unsubscribe();
    }
    if (this.tempTimeout) {
      clearTimeout(this.tempTimeout);
    }
  }

}
